import { useSelector } from "react-redux";
import { isFeatureEnabledValue, isFeatureEnabledOptInValue } from "./featureFlags";

const ConfigsSearcher = () => {
  const configs = useSelector((state) => state.gamma.appConfig);
  const configFinder = (str) => {
    if (configs?.length) {
      const keyValue = configs?.find((obj) => obj.key === str);
      return keyValue?.value || false;
    }
  };
  const isFeatureEnabled = (key) => isFeatureEnabledValue(configFinder(key));
  const isFeatureEnabledOptIn = (key) => isFeatureEnabledOptInValue(configFinder(key));
  return { configFinder, isFeatureEnabled, isFeatureEnabledOptIn };
};

export default ConfigsSearcher;
